var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { format } from 'date-fns';
import MD5 from 'md5.js';
import { record } from 'fp-ts';
import { identity } from 'fp-ts/lib/function';
import { MIN_PASSWORD_LENGTH } from '../services/auth.service';
export function formatDate(date) {
    return format(date, 'M/D/YY');
}
export function formatPrice(num) {
    if (Number.isInteger(num)) {
        return new Intl.NumberFormat('en-US').format(num);
    }
    else {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(num);
    }
}
export function capitalFirst(str) {
    return str.length ? str.charAt(0).toUpperCase() + str.substring(1) : str;
}
export function capitalWords(str) {
    return str
        .split(/\s+/)
        .map(capitalFirst)
        .join(' ');
}
export function formatInitials(name) {
    return name
        ? name
            .trim()
            .split(/\s+/, 2)
            .map(function (word) { return word[0]; })
            .join('')
        : '';
}
export function trimTrailingSlashes(str) {
    return str.replace(/\/+$/, '');
}
var animals = [
    'alligator',
    'anteater',
    'armadillo',
    'auroch',
    'axolotl',
    'badger',
    'bat',
    'beaver',
    'buffalo',
    'camel',
    'chameleon',
    'cheetah',
    'chipmunk',
    'chinchilla',
    'chupacabra',
    'cormorant',
    'coyote',
    'crow',
    'dingo',
    'dinosaur',
    'dog',
    'dolphin',
    'dragon',
    'duck',
    'elephant',
    'ferret',
    'fox',
    'frog',
    'giraffe',
    'goose',
    'gopher',
    'grizzly',
    'hamster',
    'hedgehog',
    'hippo',
    'hyena',
    'jackal',
    'ibex',
    'ifrit',
    'iguana',
    'kangaroo',
    'koala',
    'kraken',
    'lemur',
    'leopard',
    'liger',
    'lion',
    'llama',
    'manatee',
    'mink',
    'monkey',
    'moose',
    'narwhal',
    'orangutan',
    'otter',
    'panda',
    'penguin',
    'platypus',
    'python',
    'pumpkin',
    'quagga',
    'rabbit',
    'raccoon',
    'rhino',
    'sheep',
    'shrew',
    'skunk',
    'squirrel',
    'tiger',
    'turtle',
    'unicorn',
    'walrus',
    'wolf',
    'wolverine',
    'wombat',
].map(capitalWords);
var colorThemes = [
    'sugarsweets',
    'heatwave',
    'daisygarden',
    'seascape',
    'summerwarmth',
    'bythepool',
    'duskfalling',
    'frogideas',
    'berrypie',
];
export function getAnonymousName(str) {
    var hash = new MD5().update(str).digest();
    return {
        animal: animals[hash.readUInt8(0) % animals.length],
        colorTheme: colorThemes[hash.readUInt8(1) % colorThemes.length],
    };
}
var pwdValidators = {
    validLength: function (p) { return p.length >= MIN_PASSWORD_LENGTH; },
    number: function (p) { return /\d/.test(p); },
    lowercase: function (p) { return /[a-z]/.test(p); },
    uppercase: function (p) { return /[A-Z]/.test(p); },
    special: function (p) { return /[()[\]{}|`~!@#$%^&*_+=;:'",<>./?-]/.test(p); },
};
export function validatePassword(pwd) {
    var results = record.map(pwdValidators, function (fn) { return fn(pwd); });
    var valid = record.every(results, identity);
    return __assign(__assign({}, results), { valid: valid });
}
//# sourceMappingURL=string.utils.js.map